<div class="btn-group mx-3" dropdown placement="left">
	<button id="button-basic" dropdownToggle type="button" class="btn btn-info dropdown-toggle">
		Language
	</button>
	<ul *dropdownMenu class="dropdown-menu" role="menu">
		<li *ngFor="let lang of translate.getLangs()" role="menuitem">
			<a class="dropdown-item pointer" (click)="translate.use(lang)">{{langList[lang]}}</a>
		</li>
	</ul>
</div>